module.exports = __webpack_public_path__ + "static/media/viacom.25cfc665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/viacom.svg
// module id = 608
// module chunks = 0